import ScaleLoader from 'react-spinners/ScaleLoader';

const Loading = () => <ScaleLoader color="#97bf0f" loading hieght={35} width={4} radius={2} margin={2} />;

export default Loading;
